
(function (fox, $) {
	'use strict';
	
	fox.registerWidget('SestaFosta_Popup', {
		configure() {
			this.registerOptions('', {
				contentTemplate: 'sestafosta_confirm_popup',

				onOkPress: (...args) => this.sumbitForm(...args),
				onCancelPress: (...args) => this.onCancel(...args),
				widgets: {
					form: {
						widget: 'DomForm',
						formSelector: '#form-content',
						validateOnFly: false
					},
					confirmPopup: {
						widget: 'SestaFosta_Confirmanion'
					},
					'content.handleDom': {
						chracterLeft: {
							target: '#comment',
							event: 'keyup',
							callback: '@parent:chracterLeft'
						}
					}
				},
				handleWom: {
					formValidation: {
						widget: '#form',
						event: ['form_valid', 'form_not_valid'],
						callback: (infos, form) => infos.forEach(({ field, result }) => {
							const element = form.getElement(field);
							
							element.nodes.forEach((node) => {
								const label = node.parentNode.parentNode;

								if (label) {
									return !result ?
										label.classList.add('error') :
										label.classList.remove('error');
								}
							});
						})
					}
				}
			});

			this.callParent('configure', arguments);
		},
		activate(){
			this.rwom1('#content').setOption('template', 'sestafosta_confirm_popup');
			this.callParent('activate', arguments);
		},

		sumbitForm(button) {
			const confirmPopup = this.wom1('#confirmPopup');
			const sendApi = this.getApi('updateApi', {
				method: 'report.site',
				encodePost: true,
				httpMethod: 'post'
			});
			const form = this.rwom1('#form');

			return form.submit().then((values) => {
				if (values === false) {
					return null;
				}
				return sendApi.psend(values).then((resp) => {
					this.hide();
					return confirmPopup.show('sestafosta_succes_popup')
						.then(() => true);
				}).catch((err) => {
					console.log(err);
					this.hide();
					return confirmPopup.show('sestafosta_error_popup')
						.then(() => true);
				});
			});
		},
		chracterLeft(value){
			var text = value.value.length; 
			var chLeft = 500 - text;
			$('#info-ch').text(chLeft);
		}
	}, 'GDPR_BasePopup');
	

})(fox, fox.jQuery);


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/sesta-fosta/widget/sestafosta-popup.es.js